import GroupTeam from "../../components/team/GroupTeam";
import {useEffect, useState} from "react";
import {useParams, useLocation, Form} from "react-router-dom";
import NavBar from "../../components/common/NavBar";
import SeasonTeams from "../../components/team/SeasonTeams";
import TeamItem from "../../components/team/TeamItem";

export default function GroupTeamPage(props) {
    const params = useParams();
    const location = useLocation()
    const {activeSeasonData} = location.state;
    const [teams, setTeams] = useState([]);
    const [groupsList, setGroupsList] = useState([]);

    useEffect(() => {
        setTeams(activeSeasonData.teams.map((team, index) => {
            return <TeamItem team={team} key={index}/>
        }));
    }, [activeSeasonData]);

    const onAddGroupClick = () => {
        setGroupsList(groupsList.concat(<GroupTeam teams={undefined} title={`Group A`}/>));
    };

    const addGroupTeam = () => {
        console.log("Add Group Team Clicked");
    }

    const navBarElem = {
        pageTitle: "Schedule",
        links: [
            {
                pageTitle: "Organizations",
                navLink: "/management/organizations",
                active: false
            },
            {
                pageTitle: "Divisions",
                navLink: `/management/organizations/${params.orgSlug}/divisions`,
                active: false
            },
            {
                pageTitle: "Div",
                navLink: `/management/organizations/${params.orgSlug}/divisions/${params.divSlug}`,
                active: false
            },
            {
                pageTitle: activeSeasonData.name,
                navLink: null,
                active: true
            }
        ]
    };

    return (
        <>
            <div className="content-wrapper">
                <NavBar navBarElem={navBarElem}/>

                <section className="content">

                    <div className="container-fluid">
                        <Form method="post" onSubmit={e => {
                            e.preventDefault();
                        }}>
                            <div className="row">
                                <div className="col-md-12">
                                    <button type="button" className="btn btn-primary float-right"
                                            onClick={onAddGroupClick}><i
                                        className="fas fa-plus"></i> Add
                                        Group
                                    </button>
                                </div>
                            </div>
                            <br/>
                            <div className="row">

                                <div className="col-md-6">
                                    <SeasonTeams teams={teams} title="Teams"/>
                                </div>

                                <div className="col-md-6">
                                    {groupsList.map((group, index) => (
                                        <GroupTeam title={`Group ` + index} key={index} addGroupTeam={addGroupTeam}/>
                                    ))}
                                </div>
                            </div>
                        </Form>
                    </div>
                </section>
            </div>
        </>
    );
}
